<template>
  <div class="d-flex flex-column flex-md-row">
    <div class="info-wrapper bg-primary p-4">
      <h3 v-if="!!title" v-text="title" class="text-white title" />
      <div class="mt-5 text-end">
        <i
          class="fas fa-info-circle toggler text-white"
          @click="toggleInfo"
        ></i>
      </div>
    </div>
    <div class="info bg-white p-4" :class="showInfo && 'active'">
      <div v-if="!!description" v-html="description" class="" />
      <div v-if="!!link && !!link_text" class="mt-3">
        <a :href="link" v-text="link_text" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'description', 'link', 'link_text'],
  data() {
    return {
      showInfo: false,
    };
  },
  methods: {
    toggleInfo() {
      this.showInfo = !this.showInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-wrapper {
  flex: 0 0 450px;
  @media screen and (max-width: 767px) {
    flex: 1 1 auto;
  }
}
.info {
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  display: none;
  &.active {
    opacity: 1;
    visibility: visible;
    transition: all 0.3s ease-in-out;
    display: block;
  }
}
.title {
  max-width: 400px;
}
.toggler {
  cursor: pointer;
  font-size: 3rem;
}
</style>
